// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/collab/v1/collab.proto (package mono.collab.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { GetShareSettingsRequest, GetShareSettingsResponse, ListSharedWithMeRequest, ListSharedWithMeResponse, LogArtifactToChatRequest, LogArtifactToChatResponse, ResolveShareTokenRequest, ResolveShareTokenResponse, RevokeShareRequest, RevokeShareResponse, RotateShareLinkRequest, RotateShareLinkResponse, ShareConversationRequest, ShareConversationResponse, ToggleLinkShareRequest, ToggleLinkShareResponse } from "./collab_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * CollabService owns the browser-facing collaboration surface for chats:
 * history listings, share lifecycle, and public-link resolution. Sabaody
 * routes /mono.collab.v1.CollabService/* to shanks (which holds the
 * pangaea collab client) — the browser hits sabaody with a JWT, sabaody
 * authenticates and forwards gateway-auth headers, and shanks resolves
 * the call against pangaea.
 *
 * Why this lives alongside AgentService (not inside it):
 *   - AgentService is streaming-first (Chat). Lumping share-management
 *     RPCs into it would muddy the surface and bloat the wire definition
 *     for callers that only need the agent.
 *   - CRUD over conversations (list/get/update/delete) is already on
 *     AgentService. The frontend uses those for the chat-history sidebar
 *     + chat detail page; this service is purely the share-and-public-
 *     access surface that those endpoints don't cover.
 *
 * Why this is NOT in pangaea's CollaborationGatewayService:
 *   - Pangaea is admin-secret-gated and never reached by the browser.
 *     CollabService is JWT-gated via sabaody. The two services live at
 *     different trust boundaries; sharing the same proto would conflate
 *     them.
 *   - CollabService surfaces business rules (max direct shares,
 *     same-tenant link check, owner-only writes) that pangaea's data-
 *     gateway intentionally does not enforce.
 *
 * @generated from service mono.collab.v1.CollabService
 */ export const CollabService = {
    typeName: "mono.collab.v1.CollabService",
    methods: {
        /**
     * Share lifecycle.
     *
     * @generated from rpc mono.collab.v1.CollabService.ShareConversation
     */ shareConversation: {
            name: "ShareConversation",
            I: ShareConversationRequest,
            O: ShareConversationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.collab.v1.CollabService.GetShareSettings
     */ getShareSettings: {
            name: "GetShareSettings",
            I: GetShareSettingsRequest,
            O: GetShareSettingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.collab.v1.CollabService.ToggleLinkShare
     */ toggleLinkShare: {
            name: "ToggleLinkShare",
            I: ToggleLinkShareRequest,
            O: ToggleLinkShareResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.collab.v1.CollabService.RotateShareLink
     */ rotateShareLink: {
            name: "RotateShareLink",
            I: RotateShareLinkRequest,
            O: RotateShareLinkResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.collab.v1.CollabService.RevokeShare
     */ revokeShare: {
            name: "RevokeShare",
            I: RevokeShareRequest,
            O: RevokeShareResponse,
            kind: MethodKind.Unary
        },
        /**
     * Inbox.
     *
     * @generated from rpc mono.collab.v1.CollabService.ListSharedWithMe
     */ listSharedWithMe: {
            name: "ListSharedWithMe",
            I: ListSharedWithMeRequest,
            O: ListSharedWithMeResponse,
            kind: MethodKind.Unary
        },
        /**
     * Public-token resolution. Authenticated path (browser holds a JWT);
     * the *token* is the chat identity, the JWT is the caller identity.
     * Tenant check happens server-side — the share's tenant must match the
     * caller's.
     *
     * @generated from rpc mono.collab.v1.CollabService.ResolveShareToken
     */ resolveShareToken: {
            name: "ResolveShareToken",
            I: ResolveShareTokenRequest,
            O: ResolveShareTokenResponse,
            kind: MethodKind.Unary
        },
        /**
     * Append an assistant log message recording a document save (replaces
     * express's POST /api/chat/log-save). Kept on collab rather than agent
     * because it is a *side-effect* of an artifact action, not an agent
     * turn — putting it on AgentService would imply LLM involvement.
     *
     * @generated from rpc mono.collab.v1.CollabService.LogArtifactToChat
     */ logArtifactToChat: {
            name: "LogArtifactToChat",
            I: LogArtifactToChatRequest,
            O: LogArtifactToChatResponse,
            kind: MethodKind.Unary
        }
    }
};
